import { WUJIE_EVENT_NAME } from './event';

// eslint-disable-next-line import/prefer-default-export
export function useWujieMethod() {
  let bus;
  // eslint-disable-next-line no-underscore-dangle
  if (window.__POWERED_BY_WUJIE__) {
    bus = window.$wujie.bus;
  }
  function INJECT_CLOSE_MAIN_ROUTE(path) {
    if (bus) {
      bus.$emit(WUJIE_EVENT_NAME.CLOSE_MAIN_ROUTE, path);
    }
  }
  function INJECT_SUBAPP_SESSION_EXPIRE() {
    if (bus) {
      bus.$emit(WUJIE_EVENT_NAME.SUBAPP_SESSION_EXPIRE);
    }
  }
  function INJECT_SET_TASK_VISIBLE() {
    if (bus) {
      bus.$emit(WUJIE_EVENT_NAME.SET_TASK_VISIBLE, true);
    }
  }

  return {
    INJECT_CLOSE_MAIN_ROUTE,
    INJECT_SUBAPP_SESSION_EXPIRE,
    INJECT_SET_TASK_VISIBLE,
  };
}
